/**
 * The service to provide app wide alerts and notifications.
 * Contains all the methods needed for alerts and notifications.
 */
export class AlertsAndNotificationsServiceAjs {
    /*@ngInject*/
    constructor(ngNotify, ngToast, StorageService, genericService) {
        this.ngNotify = ngNotify;
        this.ngToast = ngToast;
        this.StorageService = StorageService;
        this.genericService = genericService;
        // this.urlConstants = {
        //     GET_NOTIFICATIONS: 'api/notification/findall',
        //     SET_NOTIFICATION_STATE: 'api/notification/changenotificationstate',
        //     CHANGE_STATE_FOR_ALL_NOTIFICATIONS_OF_USER: 'api/notification/changestateforallnotificationsofuser',
        //     CHANGE_STATE_FOR_NOTIFICATIONS_BY_FILTER: 'api/notification/changestatefornotificationsbyfilter'
        // }
    }
    showBannerMessage(messageData, messageType) {
        if (messageData && (typeof messageData !== "string" || (typeof messageData == "string" && !messageData.includes("Session Expired") && !messageData.includes("user cancellation")))) {
            switch (messageType) {
                case 'success':
                    this.ngNotify.set('&nbsp;' + messageData, {
                        type: 'success',
                        html: true
                        // button: true
                    });
                    break;
                case 'info':
                    this.ngNotify.set('&nbsp;' + messageData, {
                        type: 'info',
                        html: true
                        // button: true
                    });
                    break;
                case 'warning':
                    this.ngNotify.set('&nbsp;' + messageData, {
                        type: 'warn',
                        html: true,
                        button: true
                    });
                    break;
                case 'danger':
                    this.ngNotify.set('&nbsp;' + messageData, {
                        type: 'error',
                        html: true,
                        sticky: true
                    });
                    break;
                default:
                    this.ngNotify.set("Something went wrong ...... Please contact admin");
            }
        }
        else {
            console.log(messageData);
        }
    }
    // getNotifications(filterObject, successCallback, errorCallback) {
    //     let promise = this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.GET_NOTIFICATIONS, filterObject);
    //     promise.then((data) => {
    //         successCallback(data);
    //     }, (error) => {
    //         errorCallback(error);
    //     });
    //     return promise;
    // }
    // setNotificationsState(stateObject, successCallback, errorCallback) {
    //     this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.SET_NOTIFICATION_STATE, stateObject).then((data) => {
    //         successCallback(data);
    //     }, (error) => {
    //         errorCallback(error);
    //     });
    // }
    // changeStateForAllNotificationsOfUser(notificationState, successCallback, errorCallback) {
    //     this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.CHANGE_STATE_FOR_ALL_NOTIFICATIONS_OF_USER + "/?state=" + notificationState).then((data) => {
    //         successCallback(data);
    //     }, (error) => {
    //         errorCallback(error);
    //     });
    // }
    // changeStateForNotificationsByFilter(notificationState, info, successCallback, errorCallback) {
    //     this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.CHANGE_STATE_FOR_NOTIFICATIONS_BY_FILTER + "/?state=" + notificationState, info).then((data) => {
    //         successCallback(data);  
    //     }, (error) => {
    //         errorCallback(error);
    //     });
    // }
    showToastMessage(message, messageType) {
        if (messageType == 'success') {
            this.ngToast.success({
                content: message,
                verticalPosition: 'bottom',
                horizontalPosition: 'right'
            });
        }
        else if (messageType == 'warning') {
            this.ngToast.warning({
                content: message,
                verticalPosition: 'bottom',
                horizontalPosition: 'right'
            });
        }
        else if (messageType == 'danger') {
            this.ngToast.danger({
                content: message,
                verticalPosition: 'bottom',
                horizontalPosition: 'right'
            });
        }
    }
    //bootbox
    showAlert(title, message, type) {
        bootbox.hideAll();
        let alertClass = `alert-${type}`;
        let iconClass = this._getBootBoxIconClass(type);
        bootbox.alert({
            closeButton: false,
            title: `<div class='alert ${alertClass} mb-0'><i class='${iconClass}'></i><strong>  ${title} </strong></div>`,
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    }
    showConfirm(title, message, type, successCallback, cancelCallback) {
        bootbox.hideAll();
        let alertClass = `alert-${type}`;
        let iconClass = this._getBootBoxIconClass(type);
        bootbox.confirm({
            closeButton: false,
            title: `<div class='alert ${alertClass} mb-0'><i class='${iconClass}'></i><strong>  ${title} </strong></div>`,
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Ok',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    if (successCallback) {
                        successCallback();
                    }
                }
                else {
                    if (cancelCallback) {
                        cancelCallback();
                    }
                }
            }
        });
    }
    _getBootBoxIconClass(type) {
        if (type == 'warning') {
            return 'fas fa-exclamation-triangle fa-fw fa-lg';
        }
        else if (type == "danger") {
            return 'fa fa-times-circle fa-fw fa-lg';
        }
        else if (type == "success") {
            return 'fa fa-check fa-fw fa-lg';
        }
    }
}
//# sourceMappingURL=alertsAndNotificationsService.js.map